import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * Draft metadata only. The draft's event nodes live as first-class rows in
 * the draft node collection (ADR 0003) and are served via
 * `GetProcessDraftResponse.events`.
 */ export const ProcessDraftSchema = z.object({
    _id: ObjectIdSchema,
    processId: ObjectIdSchema,
    createdAt: z.date(),
    createdBy: ObjectIdSchema,
    updatedAt: z.date()
});

//# sourceMappingURL=process-draft.schema.js.map